import React,{useState,useEffect} from 'react';
import Navbar from '../components/navbar';
import Card from '../components/card';
import {Splitter} from 'antd';

import './App.css'; // 引入自定义 CSS 样式
import {orderBy,groupBy,map,minBy,maxBy,sumBy,uniq} from 'lodash';

// 默认筛选条件
const defaultFilters = {
  score: 669
};

function App() {
  const [filters,setFilters] = useState(() => {
    // This function runs only once on initial component render

    const params = new URLSearchParams(window.location.search);
    const urlScore = params.get('score');

    let initialScore = defaultFilters.score;

    if(urlScore !== null && !isNaN(Number(urlScore))) {
      // If 'score' parameter exists in URL and is a valid number, use it
      initialScore = Number(urlScore);
    }
    return {
      score: initialScore,
    };
  });
  const [data1,setData1] = useState(null);
  const [data2,setData2] = useState(null);
  // 处理导航变化
  function handlerNavChange(sectionInfo) {
    if(!sectionInfo || !sectionInfo.year || !sectionInfo.section) return;
    const fetchSpecial = async (data) => {
      let year = data.year;
      const url = `/api/special?year=${year}&section=${sectionInfo.section}&nocache=1`;
      try {
        const res = await fetch(url);
        if(!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();

        const groupedData = groupBy(json,item => `${item.school_id}-${item.sg_name}-${item.sg_info}`);

        const processedData = map(groupedData,(group) => {
          if(!group || group.length === 0) return null;
          return {
            school_id: group[0].school_id,
            sg_name: group[0].sg_name,
            sg_info: group[0].sg_info,
            school_name: group[0].school_name, // Assuming school_name is consistent per school_id
            min_section: minBy(group,'min_section')?.min_section,
            max_section: maxBy(group,'max_section')?.max_section,
            min: minBy(group,'min')?.min,
            max: maxBy(group,'max')?.max,
            num: sumBy(group,'num'),
            local_batch_name: uniq(map(group,'local_batch_name')).filter(Boolean).join(','),
            remark_tooltip: map(group,item => {
              if(item.sp_name && item.num != null) {
                return `${item.sp_name}-${item.local_batch_name}(${item.num})` + "\n" +
                  `${item.max_section ? `${item.max_section}-` : ''}` + item.min_section + ` | ${item.min}` + `${item.max ? ` - ${item.max}` : ''}` + "\n" +
                  `${item.remark}` + "\n";
              }
              return null;
            }).filter(Boolean),
            remark: map(group,item => {
              // Only include if sp_name and num are valid to avoid "null:null" strings
              if(item.sp_name && item.num != null) {
                return `${item.sp_name}(${item.num})`;
              }
              return null;
            }).filter(Boolean).join(',')
          };
        }).filter(Boolean); // Filter out any null entries that might result from empty groups

        let data1 = {
          ...data,items: orderBy(
            // Filter based on processedData, ensuring min_section is not null before comparison
            processedData.filter(f => f.min_section != null && f.min_section <= data.section),
            ['min_section'],['desc']
          )
        }
        let data2 = {
          ...data,items: orderBy(
            // Filter based on processedData, ensuring min_section is not null before comparison
            processedData.filter(f => f.min_section != null && f.min_section > data.section),
            ['min_section'],['asc']
          )
        }
        setData1(data1)
        setData2(data2);
      } catch(err) {
        console.error(`Error fetching special year ${year}:`,err);
        return [];
      }
    };
    try {
      let data = {}
      data.year = sectionInfo.selectYear
      data.score = sectionInfo.score;
      data.section = sectionInfo.section;
      fetchSpecial(data);
    } catch(err) {
      // 如果发生错误，打印错误信息，并设置数据为null
      console.error(`Error fetching year ${year}:`,err);
      setData1(null);
      setData2(null);
    }

  }

  return (
    <div >
      <Navbar filters={filters} onScoreChanged={handlerNavChange} />
      <Splitter
        style={{boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'}}
      >
        <Splitter.Panel size="50%" resizable={false}>
          <div className="split-side">
            {data1 && data1.items && data1.items.length > 0 ? (
              data1.items.map((item,index) => (
                <Card
                  key={item.school_id + item.sg_name + item.sg_info + index} // More robust key for Card component
                  item={item}
                  dataSection={data1.section}
                />
              ))
            ) : (
              <p>暂无数据</p>
            )}
          </div>
        </Splitter.Panel>
        <Splitter.Panel size="50%">
          <div className="split-side">
            {data2 && data2.items && data2.items.length > 0 ? (
              data2.items.map((item,index) => (
                <Card
                  key={item.school_id + item.sg_name + item.sg_info + index} // More robust key for Card component
                  item={item}
                  dataSection={data2.section}
                />
              ))
            ) : (
              <p>暂无数据</p>
            )}
          </div>
        </Splitter.Panel>
      </Splitter >
    </div >
  );
}

export default App;